import SignaturePad from "signature_pad";
import { storage } from "@/components/Storage";
import { render_tgo_sign } from "../functions";
import {flightSchedule} from "../Pages/FlightSchedulePage";
import {ModalContainerCHL} from "./ModalContainerCHL";


/*var ModalTGO = {
    view: function (ctrl, args) {
        let allTGOReady;
        const CardSignature = storage.config.CardSignature;
        const DenyCloseWorks = storage.config.DenyCloseWorks;

        if(flightSchedule.currentList.filter(x => (x.factBeginTime == null || x.factFinishTime == null) && !x.isCancelled).length === 0) {
            allTGOReady = true;
        } else {
            allTGOReady = false;
        }

        let modalWarningShow;

        if(!DenyCloseWorks && CardSignature) {
            modalWarningShow = false;
        } else {
            modalWarningShow = !allTGOReady;
        }



        return m('.popup',
            m(".popup-content[style='margin-top:-285px']", [
                m(".container[style='overflow: auto; max-height: 100%;']", [
                    m(".row.bg-primary[style='padding:10px;position:absolute;z-index:1;width:100%;']", [
                        m("span", "Технологическая карта"),
                        m("span.pull-right", {onclick: ModalContainerTGO.close}, [
                            m("i.glyphicon.glyphicon-remove"),
                            m.trust('&nbsp;Закрыть')
                        ]),
                        m("br"),
                        m("span", "" + args.data.flightNumber + " / " + args.data.boardNumber + ""),
                    ]),
                    [modalWarningShow ?
                        m("div[style='margin-top: 55px;']", [
                            m("b", "Перед подписанием Технологической карты требуется заполнить все времена по операциям ТГО."),
                            m("hr"),
                            m("b", "Операции, которые не применимы к данному рейсу, должны быть отменены.")
                        ])
                        :
                        m("div[style='margin-top: 55px;']", [
                            m("ul.list-group[style='margin-top: 15px;']", [
                                flightSchedule.currentList
                                    .filter(x => (x.factBeginTime !== null || x.factFinishTime !== null) && !x.isCancelled)
                                    .map(function (item) {
                                        return [
                                            m("li.list-group-item.row[style='padding: 10px 0;']", [
                                                m(".col-xs-8[style='']", [
                                                    m("span", {
                                                        class: ''
                                                    }, item.title)
                                                ]), [item.isMilestone ? [
                                                        m(".col-xs-4[style='text-align: center']", [
                                                            m("span", {}, item.factBeginTime)
                                                        ])
                                                    ] :
                                                    [
                                                        m(".col-xs-2[style='']", [
                                                            m("span", {}, item.factBeginTime)
                                                        ]),
                                                        m(".col-xs-2[style='']", [
                                                            m("span", {}, item.factFinishTime)
                                                        ])
                                                    ]
                                                ]
                                            ])
                                        ];
                                    }),
                                m(".container[style='padding-top: 15px;']", [
                                    m("b", "Подпись представителя:")
                                ]),
                                m("div.signature-pad[style='']", [
                                    m("canvas[style='border: 1px solid #000; '][id='canvasSignTGO']", ""),
                                    m(".row", [
                                        m(".col-xs-6", [
                                            m("button.btn.btn-success.btn-md", {
                                                id: "save_sign"
                                            }, "Сохранить")
                                        ]),
                                        m(".col-xs-6", [
                                            m("button.btn.btn-info.btn-md", {
                                                id: "clear_sign",
                                                onclick: function () {
                                                    var canvas = document.querySelector("canvas");
                                                    if (canvas !== null) {
                                                        var signaturePad = new SignaturePad(canvas, {
                                                            backgroundColor: 'rgb(255, 255, 255)'
                                                        });
                                                        signaturePad.clear();
                                                    }
                                                }
                                            }, "Очистить")
                                        ])
                                    ]),

                                    m("script", [
                                        //render_tgo_sign()
                                        m.trust(render_tgo_sign())
                                    ])
                                ])
                            ])
                        ])
                    ]
                ])
            ])
        );
    }
};*/

var ModalTGO = {
    view: function (ctrl, args) {
        let allTGOReady;
        const CardSignature = storage.config.CardSignature;
        const DenyCloseWorks = storage.config.DenyCloseWorks;

        if(flightSchedule.currentList?.filter(x => (x.factBeginTime == null || x.factFinishTime == null) && !x.isCancelled).length === 0) {
            allTGOReady = true;
        } else {
            allTGOReady = false;
        }

        let modalWarningShow;

        if(!DenyCloseWorks && CardSignature) {
            modalWarningShow = false;
        } else {
            modalWarningShow = !allTGOReady;
        }

        return m('div.dm-overlay',
            m("div.dm-table", [
                m("div.dm-cell", [
                    m("div.dm-modal", [
                        m(".bg-primary[style='padding:10px;z-index:1;']", [
                            m("span[id='titleModal']", "Технологическая карта"),
                            m("span.pull-right[style='cursor: pointer;']", {
                                onclick: ModalContainerTGO.close
                            }, [
                                m("i.glyphicon.glyphicon-remove"),
                                m.trust('&nbsp;Закрыть')
                            ]),
                            m("br"),
                            m("span", "" + args.data.flightNumber + " / " + args.data.boardNumber + ""),
                        ]),
                        [modalWarningShow ?
                            m("div[style='margin-top: 55px;']", [
                                m("b", "Перед подписанием Технологической карты требуется заполнить все времена по операциям ТГО."),
                                m("hr"),
                                m("b", "Операции, которые не применимы к данному рейсу, должны быть отменены.")
                            ])
                            :
                            m("div[style='margin-top: 5px;']", [
                                m("ul.list-group[style='margin-top: 15px;']", [
                                    flightSchedule.currentList
                                        .filter(x => (x.factBeginTime !== null || x.factFinishTime !== null) && !x.isCancelled)
                                        .map(function (item) {
                                            return [
                                                m("li.list-group-item.row[style='margin: 0 4px;']", [
                                                    m(".col-xs-8[style='']", [
                                                        m("span", {
                                                            class: ''
                                                        }, item.title)
                                                    ]), [item.isMilestone ? [
                                                            m(".col-xs-4[style='text-align: center']", [
                                                                m("span", {}, item.factBeginTime)
                                                            ])
                                                        ] :
                                                        [
                                                            m(".col-xs-2[style='']", [
                                                                m("span", {}, item.factBeginTime)
                                                            ]),
                                                            m(".col-xs-2[style='']", [
                                                                m("span", {}, item.factFinishTime)
                                                            ])
                                                        ]
                                                    ]
                                                ])
                                            ];
                                        }),
                                    m(".container[style='padding-top: 15px;']", [
                                        m("b", "Подпись представителя:")
                                    ]),
                                    m("div[style='margin: 15px 0; padding: 0 15px;']", [
                                        m("div.signature-pad[style='']", [
                                            m("canvas[style='border: 1px solid #000; '][id='canvasSignTGO']", ""),
                                            m(".row", [
                                                m(".col-xs-6", [
                                                    m("button.btn.btn-success.btn-md", {
                                                        id: "save_sign_TGO"
                                                    }, "Сохранить")
                                                ]),
                                                m(".col-xs-6", [
                                                    m("button.btn.btn-info.btn-md", {
                                                        id: "clear_sign",
                                                        onclick: function () {
                                                            var canvas = document.querySelector("canvas");
                                                            if (canvas !== null) {
                                                                var signaturePad = new SignaturePad(canvas, {
                                                                    backgroundColor: 'rgb(255, 255, 255)'
                                                                });
                                                                signaturePad.clear();
                                                            }
                                                        }
                                                    }, "Очистить")
                                                ])
                                            ]),
                                        ])
                                    ])
                                ])
                            ])
                        ]
                    ])
                ])
            ])
        );

    }
};

export var ModalContainerTGO = {
    container: null,
    init: function (ctrl) {
        ModalContainerTGO.container = document.querySelector('#modalContainerTGO');
        if (!ModalContainerTGO.container) {
            ModalContainerTGO.container = document.createElement('div');
            ModalContainerTGO.container.id = 'modalContainerTGO';
            ModalContainerTGO.container.hidden = true;
            document.body.appendChild(ModalContainerTGO.container);

            m.mount(ModalContainerTGO.container, m.component(ModalTGO, {data:  ctrl}));
        }
    },
    open: function (ctrl) {
        ModalContainerTGO.container = document.querySelector('#modalContainerTGO');
        if (!ModalContainerTGO.container) {
            ModalContainerTGO.container = document.createElement('div');
            ModalContainerTGO.container.id = 'modalContainerTGO';
            document.body.appendChild(ModalContainerTGO.container);

            m.mount(ModalContainerTGO.container, m.component(ModalTGO, {data: ctrl}));

        }
        ModalContainerTGO.container.hidden = false;
    },
    close: function () {
        let canvas = document.querySelector("canvas");
        if (canvas !== null) {
            let signaturePad = new SignaturePad(canvas, {
                backgroundColor: 'rgb(255, 255, 255)'
            });
            signaturePad.clear();
        }
        ModalContainerTGO.container.hidden = true;
    }
};
